<div class="agg-info-filter" data-cy="agg-info-column-filter">
  <!-- The SAME control the filter modal's editor row hosts, writing the same store. -->
  <hs-column-type-picker
    label="Compare as"
    [type]="type"
    (typeChange)="onTypeChange($event)"
  ></hs-column-type-picker>

  <select
    class="form-control form-control-sm agg-info-filter-operator"
    data-cy="agg-info-filter-operator"
    [ngModel]="operator"
    (ngModelChange)="onOperatorChange($event)"
  >
    <option *ngFor="let option of operators" [value]="option">
      {{ labelFor(option) }}
    </option>
  </select>

  <input
    *ngIf="needsValue"
    class="form-control form-control-sm agg-info-filter-value"
    data-cy="agg-info-filter-value"
    [type]="type === 'number' ? 'number' : type === 'date' ? 'date' : 'text'"
    [(ngModel)]="value"
    placeholder="Value"
  />
  <input
    *ngIf="needsValue && isRange"
    class="form-control form-control-sm agg-info-filter-value-to"
    data-cy="agg-info-filter-value-to"
    [type]="type === 'number' ? 'number' : 'date'"
    [(ngModel)]="valueTo"
    placeholder="To"
  />

  <div class="agg-info-filter-actions">
    <button
      type="button"
      class="btn btn-sm btn-link"
      data-cy="agg-info-filter-clear"
      (click)="clear()"
    >
      Reset
    </button>
    <button
      type="button"
      class="btn btn-sm btn-primary"
      data-cy="agg-info-filter-apply"
      (click)="apply()"
    >
      Apply
    </button>
  </div>
</div>
